// src/utils/gmaps.js

// Your personal API key.
// Get it here: https://console.cloud.google.com/google/maps-apis
const API_KEY = 'AIzaSyDApxfUsXUHDJ7fYgETkz_nRImNgwjAB2o';
const CALLBACK_NAME = 'gmapsCallback';
const LIBRARIES = 'geometry'

let initPromise;

export function init() {
  if (window.google && window.google.maps) {
    return Promise.resolve(window.google);
  }

  if (initPromise) return initPromise;

  initPromise = new Promise((resolve, reject) => {
    window[CALLBACK_NAME] = () => resolve(window.google);

    const script = document.createElement('script');
    script.async = true;
    script.defer = true;
    script.src = `https://maps.googleapis.com/maps/api/js?key=${API_KEY}&callback=${CALLBACK_NAME}&libraries=${LIBRARIES}&loading=async&v=weekly`;
    script.onerror = reject;
    document.querySelector('head').appendChild(script);
  });

  return initPromise;
}
